var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 27.4999C35.5228 27.4999 40 23.0227 40 17.4999C40 11.977 35.5228 7.49988 30 7.49988C24.4772 7.49988 20 11.977 20 17.4999C20 23.0227 24.4772 27.4999 30 27.4999Z",
    fill: "#554596"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50024 50.75C7.50024 39.5662 16.5665 30.5 27.7502 30.5H32.2502C43.434 30.5 52.5002 39.5662 52.5002 50.75V51C52.5002 51.8284 51.8287 52.5 51.0002 52.5C50.1718 52.5 49.5002 52.5 49.5002 52.5C49.5002 52.5 41.7771 52.4999 32.2502 52.4999H27.7502C18.2233 52.4999 10.5002 52.4999 10.5002 52.4999C10.5002 52.4999 9.82867 52.5 9.00024 52.5C8.17182 52.5 7.50024 51.8284 7.50024 51V50.75Z",
    fill: "#554596"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconPurple);
export default __webpack_public_path__ + "static/media/userIconPurple.23dbecc6b26ab1624edae90a3a8c011e.svg";
export { ForwardRef as ReactComponent };